import { render } from "./FrontPageDesignFooter.vue?vue&type=template&id=001edf02&scoped=true"
import script from "./FrontPageDesignFooter.vue?vue&type=script&lang=js"
export * from "./FrontPageDesignFooter.vue?vue&type=script&lang=js"

import "./FrontPageDesignFooter.vue?vue&type=style&index=0&id=001edf02&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001edf02"]])

export default __exports__